import { Grid } from '@mui/material'
import { useContext } from 'react'
import type { IllustrationIf } from '../interfaces/IllustrationIf'
import { LanguageContext } from '../util/LanguageContext'
import { IllustrationCard } from './IllustrationCard'

type IllustrationListProps = {
  items: IllustrationIf[]
  onEditIllustrationFile: (id: string, text: string, file: File) => void
  onEditIllustrationFullFile: (id: string, text: string, fullFile: File) => void
  onEditIllustration: (id: string, newText: string) => void
  onDeleteIllustration: (text: string) => void
}
export const IllustrationList: React.FC<IllustrationListProps> = props => {
  // 文字列変換用
  const translation = useContext(LanguageContext)

  return (
    <>
      {props.items.map(illustration => (
        <Grid item lg={6} xl={4}>
          <IllustrationCard
            title={translation['label_diagram']}
            id={illustration.illustration_id}
            text={illustration.text!}
            file={illustration.storage_path!}
            fullFile={illustration.full_storage_path!}
            onEditFile={(id, text, file) => props.onEditIllustrationFile(id, text, file)}
            onEditFullFile={(id, text, fullFile) =>
              props.onEditIllustrationFullFile(id, text, fullFile)
            }
            onEdit={(id, newText) => props.onEditIllustration(id, newText)}
            onDel={props.onDeleteIllustration.bind(null, illustration.text!)}
          />
        </Grid>
      ))}
    </>
  )
}
